import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './app';
import { startDensity } from './theme/use-density';
import { startColorScheme } from './theme/use-color-scheme';

// Per-tenant brand colours are NOT applied here: the `tenant-brand` Vite plugin
// (vite.config.ts + src/theme/brand-pack.ts) inlines the pinned airline's tokens
// into index.html at build time, so the chrome is branded before this module runs.
//
// Light/dark is the same story — the inline script in index.html has already put the
// resolved scheme on <html>. This call re-applies it and subscribes to the OS, so a
// `system` preference keeps following it for the life of the tab.
startColorScheme();
startDensity();

async function startMockServiceWorker(): Promise<void> {
  if (!import.meta.env.DEV) return;
  if (import.meta.env.VITE_MSW !== 'true') return;
  const { worker } = await import('./lib/msw/browser');
  await worker.start({
    onUnhandledRequest: 'bypass',
    serviceWorker: { url: '/mockServiceWorker.js' },
  });
}

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

void startMockServiceWorker().finally(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
  document.getElementById('nexa-preboot')?.remove();
});
